import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import moment from 'moment';

import { truncateText } from 'components/SharedFunctions';
import { maybeConvertDraftToHtml } from 'components/InputField/RichTextEditor/utils';
import './styles.less';
import { Quote } from 'Icons';
import slColors from 'sl-colors';

const SummaryItem = ({
  overlapStartDate,
  overlapEndDate,
  companyName,
  publicSummary,
  workRelationship,
  referencerTitle,
}) => {
  const [isShowMore, _setIsShowMore] = useState(true);
  const ref = React.useRef();
  const [truncatedSummaryHtml, setTruncatedSummaryHtml] = React.useState('');
  const summaryHtml = maybeConvertDraftToHtml(publicSummary || '');

  React.useLayoutEffect(() => {
    if (ref.current) {
      setTruncatedSummaryHtml(truncateText(ref.current.innerText));
    }
  }, []);

  return (
    <div className="summary-item tw-grid sm:tw-flex sm:tw-flex-row sm:tw-gap-8">
      <div className="tw-flex tw-flex-col tw-text-sm tw-basis-52 tw-shrink-0">
        <span className="tw-font-semibold">{referencerTitle}</span>
        <span className="tw-font-semibold">{workRelationship}</span>
        <span className="tw-block">{companyName}</span>
        {overlapStartDate && (
          <span className="tw-block">
            {moment(overlapStartDate).format('MM/YYYY')} -{' '}
            {moment(overlapEndDate).format('MM/YYYY')}
          </span>
        )}
      </div>
      <div className="tw-flex tw-flex-row tw-gap-2">
        <div className="tw-mt-1">
          <Quote width={12} height={12} color={slColors.gray[800]} transform="scale(-1, 1)" />
        </div>
        <span
          className={classNames('public-summary', {
            'no-truncate': isShowMore,
            'tw-text-gray-600 tw-italic': !summaryHtml,
          })}
        >
          {isShowMore ? (
            <span dangerouslySetInnerHTML={{ __html: summaryHtml }} />
          ) : (
            truncatedSummaryHtml || 'No public summary provided.'
          )}
        </span>
      </div>
      <div className="tw-hidden" ref={ref} dangerouslySetInnerHTML={{ __html: summaryHtml }} />
    </div>
  );
};
SummaryItem.propTypes = {
  overlapStartDate: PropTypes.string,
  overlapEndDate: PropTypes.string,
  companyName: PropTypes.string.isRequired,
  workRelationship: PropTypes.string.isRequired,
  referencerTitle: PropTypes.string.isRequired,
  publicSummary: PropTypes.string,
};

export default SummaryItem;
